import { useEffect, useState } from "react";

export const useVisibilityObserver = (elementRef) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const element = elementRef.current;
    if (!element) return undefined;

    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        setIsVisible(true);
        observer.disconnect();
      }
    }, { rootMargin: "120px 0px", threshold: 0.01 });

    observer.observe(element);

    return () => observer.disconnect();
  }, [elementRef]);

  return {
    isVisible,
  };
};
